import { IIsiDtoPlHierarchicalResponse, IsiDtoPlHierarchicalRequest, IsiDtoPlHierarchicalResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlHierarchical";
import { Mode } from "../../Dtos/Isilog.IsiFramework.IsiDataTransferObject.IsiGrid";
import { IsiGridView } from "../../IsiWebGUI/IsiFW/Components/Grid/IsiGridView";
import { IsiHierarchicalGrid } from "../../IsiWebGUI/IsiFW/Components/Grid/IsiHierarchicalGrid.component";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiIWSAssociatedViewContext } from "../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IsiPresentationLogic } from "./IsiPresentationLogic";


/**
 * Gestion du mode hierarchique/mode classique d'une DA possiblement hierarchique
 * */
export class IsiPlHierarchical extends IsiPresentationLogic {

    constructor() {
        super("IsiPlHierarchicalHandler");
    }
    /**
     * Lance le changement de mode de la grille.
     * @param mode
     * @param gridContext
     * @param menuId
     */
    public changeMode(mode: Mode, gridContext: IsiIWSAssociatedViewContext, menuId: string): Promise<IIsiUIFlowResult> {

        return new Promise((resolve,reject) => {
            window.sCodeLibelleStatus = LOADING;
            this._saveLastMode(mode).then((response) => {
                this._updateDisplay(mode, gridContext, menuId);
                resolve({ continue: false, result: true });
            }).catch(() => {
                reject(null);
            });
        });
    }
    /**
     * Met à jour l'interface graphique 
     * @param mode
     * @param gridContext
     * @param menuId
     */
    private _updateDisplay(mode: Mode, gridContext: IsiIWSAssociatedViewContext, menuId: string) {
        (uiCore.componentManager.getComponent<IsiGridView>(gridContext.gridViewId)._getGrid() as IsiHierarchicalGrid).ChangeMode(mode);
        uiCore.menuManager.hide(menuId, false);

        if (mode === Mode.Hierarchique) {
            uiCore.menuManager.show(menuId.replace(DATA_HIERARCHICMODE_ITEM, DATA_CLASSICMODE_ITEM), false);
        } else {
            uiCore.menuManager.show(menuId.replace(DATA_CLASSICMODE_ITEM, DATA_HIERARCHICMODE_ITEM), false);
        }
    }
    /**
     * Lance la sauvegarde du paramère dans les params utilisateurs
     * @param mode
     */
    private _saveLastMode(mode: Mode): Promise<IIsiDtoPlHierarchicalResponse> {
        return new Promise<IIsiDtoPlHierarchicalResponse>((resolve, reject) => {

            const dto = IsiDtoPlHierarchicalRequest.fromJS({
                mode: mode,
                response: IsiDtoPlHierarchicalResponse.fromJS({
                })
            });
            

            this.ajax("SaveGridMode", dto, true).then(
                (request) => {
                    resolve(request.response)
                }
            ).catch(() => {
                reject(null);
            });
        });

    }

    /**
     * Permet de tout étendre ou tout replier sur une grille hierarchique
     * @param gridContext
     * @param actionId
     * @returns
     */
    public expandCollapse(id: string, actionId: string): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            const dto = IsiDtoPlHierarchicalRequest.fromJS({
                gridId: id,
                actionId: actionId,
                response: IsiDtoPlHierarchicalResponse.fromJS({
                })
            });

            this.ajaxWithErrorHandling("ExpandCollapse", dto, true).then(() => {
                resolve({continue:true,result:true})
            });         
        });
    }
}